import { useState } from "react";
import "./login.css";
import { useAuthContext } from "../../hooks/useAuthContext";
import axios from "axios";

function Login() {
  const { dispatch } = useAuthContext();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null); // Clear previous errors

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/mandoub/login`,
        { email, password },
      );

      if (response.status === 200) {
        dispatch({ type: "LOGIN", payload: response.data });
        localStorage.setItem('authMandoub', JSON.stringify(response.data));
      }
    } catch (err) {
      console.error("Login failed:", err);
      setError("فشل تسجيل الدخول. الرجاء التحقق من بياناتك والمحاولة مرة أخرى.");
    }
  };

  return (
    <div className="login--container">
      <form onSubmit={handleSubmit} className="form login">
        <span className="title">تسجيل الدخول</span>

        {error && <p className="error-message my-4 text-red-600">{error}</p>}

        <div className="input-field">
          <input
            type="email"
            id="email"
            className="email"
            placeholder="أدخل بريدك الإلكتروني"
            autoComplete="off"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <i className="uil uil-envelope icon"></i>
        </div>

        <div className="input-field">
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            placeholder="أدخل كلمة المرور"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <i className="uil uil-lock icon"></i>
          <i
            className={`uil ${showPassword ? "uil-eye" : "uil-eye-slash"} showHidePw`}
            onClick={() => setShowPassword((prev) => !prev)}
          ></i>
        </div>
        


        <div className="input-field button">
          <input type="submit" value="تسجيل الدخول" />
        </div>

        
      </form>
    </div>
  );
}

export default Login;
